<div class="date-container">
    <label class="date-label">{{labelText}}</label>
    <div class="component-input">
        <input placeholder="'DD/MM/YYYY'" class="input" [min]="minDate" [max]="maxDate" [(ngModel)]="dateModel" [placeholder]="placeholder" [required]="required" 
        [ngClass]="{'input__invalid': !validate()}" (ngModelChange)="onChange($event)" [matDatepicker]="picker">
    <label class="warning-label" *ngIf="submitted && warningLabel && !validate">{{warningLabel}}</label>
    <mat-datepicker-toggle class="date-picker--toggle" matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker  #picker></mat-datepicker>
    </div>
</div>